import billingData from './billingData'
import contractorData from './contractorData'
import financialManagerData from './financialManagerData'
import checkoutWarning from './checkoutWarning'
import brokerCompanyInfo from './brokerCompanyInfo'
import brokerInfo from './brokerInfo'

export default {
  billingData,
  contractorData,
  financialManagerData,
  checkoutWarning,
  brokerCompanyInfo,
  brokerInfo,
}
